//************************************************************************ /
// CTA CARD
// Colored card suggesting an action to the user and providing a link to do it.
//************************************************************************ /

import React from "react";
import { Card, Button } from "@dreambigger/design-system/src/components";
import hover from "../../styles/hover.module.scss";
import anim from "@dreambigger/shared/src/components/board/styles/animations.module.scss";
import { CommunityCustomDataFeedItem } from "@dreambigger/shared/src/types";
import { useGA } from "@dreambigger/shared/src/hooks";
import { useMixpanel, useSegment } from "@dreambigger/shared/src/hooks";
import { useRouter } from "next/router";
import InspireAnalytics, {
  InspireAnalyticsHelper,
  InspireAnalyticEvents,
} from "@dreambigger/shared/src/utils/inspire-analytics-helper";

type CtaCardProps = {
  feedItem: CommunityCustomDataFeedItem;
  firstInFeed: boolean;
};

const CtaCard = ({ feedItem, firstInFeed }: CtaCardProps) => {
  const { cta, href, image, title } = feedItem;
  const router = useRouter();

  // Load Analytics
  const googleAnalytics = useGA();
  const mixpanel = useMixpanel();
  const segment = useSegment();

  // Do not load card if an href hasn't been provided.
  if (!href) {
    return <></>;
  }

  const handleCardClick = () => {
    // Record card click in analytics
    googleAnalytics.event({
      category: "External Card - Event",
      action: "Selected",
      label: "Clicked CTA Text:" + cta,
      value: 1,
    });
    InspireAnalytics.track({
      eventName: InspireAnalyticEvents.CARD_SELECTED,
      properties: {
        "Card Type": "feedcta",
        "Page Type": InspireAnalyticsHelper.getPageType(router.route),
      },
      mixpanel,
      segment,
    });
    // Redirect to href in a new tab
    window.open(href, "_blank");
  };

  return (
    <Card
      style={{
        boxShadow: "rgba(0, 0, 0, 0.16) 0px 1px 4px",
        background: image ? `url(${image})` : "#383838",
      }}
      bodyStyle={{ padding: "30px 24px" }}
      className={`${anim.enter_m} lift mh-auto bn pointer`}
      onClick={handleCardClick}
    >
      <div className="flex flex-column items-center">
        {/* Call To Action Text */}
        <h4 className="white tc fwb f-5 mb-6 lh-3">{title}</h4>
        {/* Button Link */}
        <Button
          onClick={handleCardClick}
          type="primary"
          className="lightenPrimaryBkd bg-primary b-primary ttu"
        >
          {cta}
        </Button>
      </div>
    </Card>
  );
};

export default CtaCard;
